export default __webpack_public_path__ + "static/media/elad.c41c7225.png";